import React from "react"
import { Link } from "react-router-dom";
import styled from "styled-components"
import { IRISBlueDivider, ReportText, TextSpan } from "../components/Common/SharedStyledComponents";
import { IrisColors } from "../css/IRISColors";
import { ReportInfo } from "../interface/ReportInfoInterface";

import { DashboardText } from "./DashboardContainer";
import { findReportViaURLPath } from "./DashboardReportsInfo";

interface PropTypes {
    currentReport?: ReportInfo
    currentUrl?: string
}

const DashboardReportActionsBar = ({ currentReport, currentUrl }: PropTypes) => {

    if (!currentReport) {
        currentReport = findReportViaURLPath(currentUrl);
    }

    const { methodologyUrl, isSharedReport } = currentReport;

    return (
        <>
            <ActionsBar>
                {!isSharedReport &&
                    <ActionLink to="/reports">
                        <DashboardText bold >← All Reports</DashboardText>
                    </ActionLink>
                }
                <ActionsGroup>
                    {/*TODO: add action buttons to report actions group*/}
                    {/*it requires possibly rewriting these functions for all the reports*/}
                    {/*downloadDataAction, downloadPDFAction, shareReportAction*/}
                    {/*{*/}
                    {/*    methodologyUrl &&*/}
                    {/*    <ActionButton type="button" className="btn btn-outline-primary float-right" onClick={() => downloadPDFAction()} >*/}
                    {/*        <DashboardText bold >*/}
                    {/*            Download Report as PDF*/}
                    {/*        </DashboardText>*/}
                    {/*    </ActionButton>*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    downloadDataAction &&*/}
                    {/*    <DashboardText bold >*/}
                    {/*        <TextSpan bold> · </TextSpan>*/}
                    {/*        <ExternalLink target="_blank" rel="noopener noreferrer" href={methodologyUrl}>Download Report Data File(s)</ExternalLink>*/}
                    {/*    </DashboardText>*/}
                    {/*}*/}
                    {
                        methodologyUrl &&
                        <DashboardText bold >
                            {/*<TextSpan bold> · </TextSpan>*/}
                            <ExternalLink target="_blank" rel="noopener noreferrer" href={methodologyUrl}>Download Methodology</ExternalLink>
                        </DashboardText>
                    }
                    {/*{*/}
                    {/*    shareReportAction &&*/}
                    {/*    <DashboardText bold >*/}
                    {/*        <TextSpan bold> · </TextSpan>*/}
                    {/*        <ExternalLink target="_blank" rel="noopener noreferrer" href={methodologyUrl}>Share Report</ExternalLink>*/}
                    {/*    </DashboardText>*/}
                    {/*}*/}
                </ActionsGroup>
            </ActionsBar>
            <IRISBlueDivider />
        </>
    );
}

const ActionsBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;
    padding-inline: 15px;
    padding-block: 5px;
    background-color: ${IrisColors.white};
`;

const ActionLink = styled(Link)`
    height: 100%;
    font-size: 15px;
    color: ${IrisColors.irisLogoBlue};
    &:hover {
        text-decoration: none;
        color: ${IrisColors.irisLogoRed};
        cursor: pointer;
    }
`;

const ExternalLink = styled.a`
    height: 100%;
    font-size: 15px;
    color: ${IrisColors.irisLogoBlue};
    &:hover {
        text-decoration: none;
        color: ${IrisColors.irisLogoRed};
        cursor: pointer;
    }
`;

const ActionButton = styled.button``;

//<button type="button" className="btn btn-outline-primary float-right" onClick={() => showSharedLinkForm()} >Share Report</button>

const ActionsGroup = styled.div`
    display: flex;
    margin-left: auto;
`;

export default DashboardReportActionsBar;